import { DialogContent, Box, Typography, Grid } from '@mui/material'
import UploadFileItem from 'components/Input/UploadFile'
import React from 'react'
import { RiArrowLeftSFill, RiArrowRightSFill } from 'react-icons/ri'
import { I18n, Extension } from 'utilities/utilities'
import TableActivityOverview from '../../components/Table/TableActivityOverview'

function TableContent(props) {
    const { loadingComplete, dataActivity, lstFileMOU, setLstFileMOU, lstFilePlan, setLstFilePlan, selectYear, startYear, setSelectYear, setStartYear } = props
    return (
        loadingComplete ? (
            <DialogContent
                sx={{
                    minWidth: "600px",
                }}
            >
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <TableActivityOverview
                            data={dataActivity}
                            onDelete={() => { }}
                            onEdit={() => { }}
                            nEditID={0}
                            nEditParentID={0}
                        />
                    </Grid>

                    <Grid item xs={12}>
                        <UploadFileItem
                            id={`arrFileMOU`}
                            name={`arrFileMOU`}
                            label={I18n.SetText("FundPlan.FileMOU")}
                            IsDrag={false}
                            required={false}
                            arrFile={lstFileMOU}
                            setarrFile={setLstFileMOU}
                            IsFolder={false}
                            IsMultiple
                            Extension={[...Extension.FileTicket, ...Extension.Word]}
                            nLimitFile={30}
                            sLimitFile={"MB"}
                            onClearFile={() => { }}
                            modeDisplay={"list"}
                            sFolderTemp={"FundWork"}
                            sPositionText={"right"}
                            disabled
                            IsHide
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <UploadFileItem
                            id={`arrFilePlan`}
                            name={`arrFilePlan`}
                            label={I18n.SetText("FundPlan.FilePlan")}
                            IsDrag={false}
                            required={false}
                            arrFile={lstFilePlan}
                            setarrFile={setLstFilePlan}
                            IsFolder={false}
                            IsMultiple
                            Extension={[...Extension.FileTicket, ...Extension.Word]}
                            nLimitFile={30}
                            sLimitFile={"MB"}
                            onClearFile={() => { }}
                            modeDisplay={"list"}
                            sFolderTemp={"FundWork"}
                            sPositionText={"right"}
                            disabled
                            IsHide
                        />
                    </Grid>
                </Grid>
            </DialogContent>
        ) : (
            <DialogContent
                sx={{
                    minWidth: "600px",
                    userSelect: "none",
                    width: "auto"
                }}
            >
                <Grid container spacing={1}>
                    <Grid
                        item
                        xs={2}
                        sx={{ display: "flex", alignItems: "center" }}
                    >
                        <RiArrowLeftSFill
                            onClick={() =>
                                setStartYear((prev) => prev - 12)
                            }
                            style={{
                                fontSize: "1.25rem",
                                color: "rgb(52, 71, 103)",
                                cursor: "pointer",
                            }}
                        />
                    </Grid>
                    <Grid item xs={8}>
                        <Box
                            sx={{
                                background: "#eee",
                                borderRadius: "0.5rem",
                                padding: "0.25rem",
                            }}
                        >
                            <Typography
                                sx={{
                                    textAlign: "center",
                                    color: "rgb(52, 71, 103)",
                                    fontWeight: 500,
                                }}
                            >
                                {startYear} - {startYear + 11}
                            </Typography>
                        </Box>
                    </Grid>
                    <Grid
                        item
                        xs={2}
                        sx={{
                            justifyContent: "flex-end",
                            display: "flex",
                            alignItems: "center",
                        }}
                    >
                        <RiArrowRightSFill
                            onClick={() =>
                                setStartYear((prev) => prev + 12)
                            }
                            style={{
                                fontSize: "1.25rem",
                                color: "rgb(52, 71, 103)",
                                cursor: "pointer",
                            }}
                        />
                    </Grid>
                </Grid>
                <Grid container spacing={1} sx={{ mt: 2 }}>
                    {[...Array(12)].map((_, index) => (
                        <Grid item xs={3} key={`year_${index + 1}`}>
                            <Box
                                sx={{
                                    background:
                                        selectYear === startYear + index
                                            ? "#1976d2"
                                            : "none",
                                    color:
                                        selectYear === startYear + index
                                            ? "#fff"
                                            : "#000",
                                    borderRadius: "0.5rem",
                                    padding: "0.25rem",
                                    cursor: "pointer",
                                }}
                                onClick={() =>
                                    setSelectYear(startYear + index)
                                }
                            >
                                <Typography
                                    sx={{ textAlign: "center" }}
                                >
                                    {startYear + index}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </DialogContent>
        ))
}

export default TableContent